var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full p-5"},[(_vm.isDataReady)?_c('apexchart',{attrs:{"options":_vm.chartOptions,"series":_vm.series,"type":"line","height":"400"}}):_c('div',[_vm._v("Loading...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }